import PropTypes from 'prop-types';
import React from 'react';
import ErrorIcon from './ErrorIcon';
import ErrorMessage from './ErrorMessage';
import HorizontalCardIcon from '../shared/HorizontalCardIcon';

const ErrorHorizontal = ({card, isAccessDenied}) => (
  <HorizontalCardIcon icon={<ErrorIcon isAccessDenied={isAccessDenied} />}>
    {card ? (
      <span>{card.title}</span>
    ) : (
      <ErrorMessage isAccessDenied={isAccessDenied} />
    )}
  </HorizontalCardIcon>
);

ErrorHorizontal.propTypes = {
  card: PropTypes.object,
  isAccessDenied: PropTypes.bool,
};

export default ErrorHorizontal;
